/**
 * Unified date utilities for date comparisons
 */

/**
 * Check if two dates are the same day (year, month, date)
 */
export function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

/**
 * Check if a date string represents today
 */
export function isToday(date: string | Date, today: Date = new Date()): boolean {
  const checkDate = typeof date === "string" ? new Date(date) : date;
  return isSameDay(checkDate, today);
}
